import type { ApiDevicePairingType } from '../../../apps/api-hono/src/routes/api_device_pairing/_router'
import { hc } from 'hono/client'
import { getEnvVariable } from '@lib/utils/getEnvVariable';
import { getClientRequestOptions } from './getClientRequestOptions';

const client = hc<ApiDevicePairingType>('')
type Client = typeof client

export const createDevicePairingApiClient = (...args: Parameters<typeof hc>): Client => {
    return hc<ApiDevicePairingType>(...args)
}

export const devicePairingApiClient = createDevicePairingApiClient(
    `https://${getEnvVariable('PUBLIC_API_DOMAIN')}/device_pairing/`,
    getClientRequestOptions()
)
